// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-text[data-v-569b0449]{font-size:14px;font-weight:500}.refresh-icon[data-v-569b0449]{display:inline-block;width:16px;height:16px}.refresh-icon.spinning[data-v-569b0449]{animation:spin-569b0449 1s linear infinite}@keyframes spin-569b0449{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
